"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    AUTH_BASE_URL: 'https://cas.s3.sceenic.co',
    HTTP_BASE_URL: 'https://sync.s3.sceenic.co/',
    WS_URl: 'wss://sync.s3.sceenic.co/ws',
    maxDelta: 5000,
    minDelta: 100,
    pingInterval: 5000
};
//# sourceMappingURL=index.js.map